import { gql } from '@apollo/client'

export const connectSocialProfilesMutation = gql`
  mutation ConnectSocialProfiles($profiles: [SocialProfilePendingInput!]!) {
    connectSocialProfiles(profiles: $profiles)
  }
`
